import { SurveyResolvedResponse } from './survey-resolved-response.interface';
import { SurveySourceVariable } from './survey-source-variable.interface';

export interface SurveyResolvedDetail {
  responses: SurveyResolvedResponse[];
  sourceVariables: SurveySourceVariable[];
}
